export default "__VITE_ASSET__DIVSr$Mc__"